import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-common-file-upload',
  templateUrl: './common-file-upload.component.html',
  styleUrls: ['./common-file-upload.component.scss']
})
export class CommonFileUploadComponent implements OnInit {

  @Input() label: string = '';
  @Input() accept: string = '.pdf, .doc, .docx';
  @Input() file: File | null = null;
  @Input() placeholder: string = 'Upload file here for eg. pdf, doc';
  @Input() required: boolean = false;
  @Input() icon: string = 'assets/icons/upload-ico.svg';
  @Output() fileChange: EventEmitter<File> = new EventEmitter<File>();

  constructor() { }

  /**
   * To initialize data
   */
  ngOnInit() {
  }

  /**
   * To handle file select
   */
  onFileSelect(event: any) {
    if (!event || !event.target.files || event.target.files.length == 0) {
      return;
    }
    const file = event.target.files[0];
    if (!file) return;
    this.fileChange.emit(file);
  }

  /**
   * To handle file upload btn click
   */
  triggerInput(inputElm: HTMLInputElement) {
    inputElm.click();
  }

}
